import Comparateur from './components/Wiin/Comparateur'
import Login from './components/Wiin/Login'
import Details from './components/Wiin/Details'
import DetailsAncien from './components/Wiin/DetailsAncien'
import company from './components/Wiin/Company'
import client from './components/Wiin/Clients'
import Users from './components/Wiin/Users'
import CreateClient from './components/Wiin/CreatClient'
import CreateUser from './components/Wiin/CreateUser'
import Account from './components/Wiin/myAccount'
import Alert from './components/Wiin/Alerts'
import Restitution from './components/Wiin/Restitutions'
import EditClient from './components/Wiin/UpdateClient'
import EditUser from './components/Wiin/UpdateUser'
import { isLoggedIn } from './utils/auth'
import Store from './Store/Store'
import ComparateurAncien from './components/Wiin/ComparateurAncien'
import ComparateurAncienV2 from './components/Wiin/ComparateurAncienV2'

export const routes=[
    {
        path:'/user/login',
        name: 'login',
        component: Login,
        meta: {
            allowAnonymous: true
        } 
    }, 
    {
        path:'/Comparateur-ancien/details/:id',
        name:'details-ancien',
        props: route => ({query: route.query.item}),
        component: DetailsAncien
    },
    {
        path:'/Comparateur-ancienold',
        component: ComparateurAncien, 
    },
    {
        path:'/Comparateur-ancien',
        component: ComparateurAncienV2, 
    }, 
    {
        path:'/Comparateur',
        component: Comparateur, 
    }, 
    {
        path:'/Comparateur/details/:id',
        name:'details',
        props: route => ({query: route.query.item}),
        component: Details
    },
    {
        path:'/company',
        component: company
    },
    {
        path:'/client',
        component: client,
    },
    {
        path:'/client/create',
        component : CreateClient 

    },
    {
        path:'/users/create',
        component : CreateUser 

    },
    {
        path:'/users/:id/edit',
        name:'editUser',
        props: route => ({query: route.query.user}),
        component : EditUser 

    },
    {
        path:'/client/:id/edit',
        name:'editClient',
        component : EditClient 

    },
    {
        path:'/searchAlert',
        component: Alert
    },
    {
        path:'/restitution',
        component: Restitution
    },
    {
        path:'/my-account',
        component : Account 

    },
    {
        path:'/users',
        component : Users,

    },
    // {
    //     path: '*',
    //     redirect: '/Comparateur'
    // }
       
]